export const ELEMENT_HOVER_CARD = 'hoverCard';
